import React, { useState, useEffect } from 'react';
import { MenuData } from '../../public/MenuData';
import { ajaxor2 } from '../common/basic';

import getNLS from '../common/_NLS';

import SubMenuCampus from "../popup/SubMenuCampus";
import SubMenuStreet from "../popup/SubMenuStreet"; // street
import SubMenuFestival from "../popup/SubMenuFestival"; // festival
import SubMenuBrand from "../popup/SubMenuBrand";

export default props=>{
  const [rootMenu, setRoot]=useState('');
  const [dMain, setMainMenu] = useState('');
  const [dSub, setSubMenu] = useState('');

  useEffect(() => {
    setSolid("pan3.dMain " + dMain);
    return () => { ; };
  }, [dMain]);

  // 모바일 메뉴를 보이거나 숨기거나 한다.
  useEffect(() => {
    if (dMain == '' && props.hideMobileMenu) {
      setMainMenu('none');
      props.hideMobileMenu();
      return;
    }

    setMainMenu(props.isMM);
    return () => { ; };
  }, [props.isMM]);

  // 루트메뉴를 감시해서 서브메뉴에 반영한다.
  useEffect(() => {
    if (rootMenu == '') {
      ////////////이거 하다가 말았다.
      setSubMenu('none');
      return;
    }
    setSubMenu('block');
    return () => {;};
  }, [rootMenu]);

  if (process.browser) window.unsets.setSubMenu = () => setSubMenu("none");



  function toggleRootMenu(from){
    if (from == rootMenu) setRoot('');
    else setRoot(from);
    ;
  }

  
  const [vNounCampuses, setNounCampuses] = useState([]);
  const [vStreets, setStreets] = useState([]);
  const [vFestivals, setFestivals] = useState([]);

  // 브랜드 카테고리정보 얻기
  const [vAlphabetBrands, setAlphabetBrands] = useState([]);
  useEffect(() => {
    ajaxor2({
      url: "/selectAllDictionary",
      callback: cb,
    });
    function cb(rd) {
      var dictionary={};
      rd.map((v,i)=>{
        dictionary[v.title] = JSON.parse(v.jdata);
      });
      setNounCampuses(dictionary.campusCategory);
      setStreets(dictionary.streetCategory);
      setFestivals(dictionary.festivalCategory);
      setAlphabetBrands(dictionary.brandCategory);
    }
    
    return () => { ; }
  }, []);

  let subMap = {
    'campus': <SubMenuCampus indexes={MenuData.campusIndex} items={vNounCampuses} />
    , 'street': <SubMenuStreet items={vStreets} />
    , 'festival': <SubMenuFestival items={vFestivals} />
    , 'brand': <SubMenuBrand indexes={MenuData.brandIndex} items={vAlphabetBrands}/>
    // , 'etc': <SubMenuETC indexes={MenuData.brandIndex} items={MenuData.etc} />
  };

  let subMenu = subMap[rootMenu];


  const jsx = (<div className="pan3 generalfont" >

    <style jsx>{`
  * {
    box-sizing: border-box;
    margin:0;
    border:0;
    padding:0;
  }

.pan3{
  width: 100%;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;

  margin: 10px auto;
  // border: solid;
  background-color: #ffffff;
}


.display-inline{
  display: inline-block;
  margin: 0 7px;
  vertical-align: middle;
  
}

.highlightable{
  height: 45px;

  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: -0.29px;
  background-color:white;
  color: #adb5bd;

  padding-top: 8px;
}

.highlighted{
  color: black;

}

.generalfont{
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #adb5bd;

}

.see{
  float:right;
  margin-top: 5px;
}

.down-icon{
  background-color: white;
  vertical-align: bottom;
}

.highlighted .down-icon{
  transform: scaleY(-1);
}


.x2{
    float: right;
    margin: 20px;
}


@media all and (max-width:606px) {
  .pan3{
    display: ${dMain};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    margin:0;
    padding: 0;
  }

  .mbuffer{
    width: 50%;
    height: 60px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }

  .mbuffer img{
    display:none;
  }
  .see{
    display:none;
  }

  .highlightable{
    /* 0418 모바일 팝업메뉴 각항목 폰트, 눈으로 확인하여 20으로하기로함 */
    font-size: 20px;
  }
}


`}</style>

    <img className="x2 dibom" onClick={props.hideMobileMenu} src="/assets/images-m/x_2.svg" />
    <div className="dbom">&nbsp;</div>
    <div className="dbom">&nbsp;</div>
    <div className="dib mbuffer">
      <a onClick={() => toggleRootMenu("campus")} >
        <div className={"display-inline highlightable hiddenable " + (dSub == 'block' && rootMenu == "campus" ? " highlighted " : null)}>
          {getNLS("캠퍼스")}
          <img className="down-icon" onClick={(e) => { setRoot(''); e.preventDefault();}} src="/assets/images2/group-11-copy-3.svg" />
        </div>
      </a>
    </div>
    <div className="dib mbuffer">
      <a onClick={() => toggleRootMenu("street")} >
        <div className={"display-inline highlightable hiddenable " + (dSub == 'block' && rootMenu == "street" ? " highlighted " : null)}>
          {getNLS("스트리트")}
          <img className="down-icon" src="/assets/images2/group-11-copy-3.svg" />
        </div>
      </a>
    </div>
    <div className="dib mbuffer">
      <a onClick={() => toggleRootMenu("festival")} >
        <div className={"display-inline highlightable hiddenable " + (dSub == 'block' && rootMenu == "festival" ? " highlighted " : null)}>
          {getNLS("페스티벌")}
          <img className="down-icon" src="/assets/images2/group-11-copy-3.svg" />
        </div>
      </a>
    </div>
    <div className="dib mbuffer">
      <a onClick={() => toggleRootMenu("brand")} >
        <div className={"display-inline highlightable hiddenable " + (dSub == 'block' && rootMenu == "brand" ? " highlighted " : null)}>
          {getNLS("브랜드")}
          <img className="down-icon" src="/assets/images2/group-11-copy-3.svg" />
        </div>
      </a>
    </div>

    {props.lookaround?
    <a href="/lookaround">
      <img className="see mouse-aa" src="/assets/images/group-5.svg" />
    </a>
    :null}
    

    <div className="submenu hiddenable" style={{ display: dSub }}>
      {/* <SubMenuCampus indexes={MenuData.campusIndex} items={MenuData.campus} />
      <SubMenu items={MenuData.street} />
      <SubMenu items={MenuData.festival} />
      <SubMenuBrand indexes={MenuData.brandIndex} items={MenuData.brand} /> */}
      {subMenu}
</div>

  </div>);
  return (jsx);
};
